import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCheckboxActive = function SvgCheckboxActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75-.001A2.25 2.25 0 0 1 24 2.249v19.5a2.25 2.25 0 0 1-2.25 2.25H2.25A2.25 2.25 0 0 1 0 21.749v-19.5a2.25 2.25 0 0 1 2.25-2.25h19.5Zm0 1.5H2.25a.75.75 0 0 0-.75.75v19.5c0 .414.336.75.75.75h19.5a.75.75 0 0 0 .75-.75v-19.5a.75.75 0 0 0-.75-.75Zm-4.338 4.864a.75.75 0 1 1 1.176.93l-7.834 9.912a1.795 1.795 0 0 1-2.917-.073l-2.45-3.477a.75.75 0 0 1 1.226-.864l2.46 3.492a.299.299 0 0 0 .496.003Z",
    fillRule: "evenodd"
  })));
};

export { SvgCheckboxActive as ReactComponent };
//# sourceMappingURL=checkbox-active.svg.js.map
